import React from 'react'
import spinner from '../images/spinner.gif'

export default function Aguarde(props) {

    if (!props) {
        return null
    }

    if (!props.showAguarde) {
        return null
    }

    return (
        <div className="molduraSpinner">
            <div className="spinner">
                <img src={ spinner } alt="Aguarde..." />
            </div>
        </div>
    )
}